import ProfileDialogComponent from "./profileDialog.component";

export default function ProfileDialogContainer({
  open,
  handleClose,
  handleSubmit,
}) {
  return (
    <ProfileDialogComponent
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
}
